import { Classes, H2, H3 } from "@blueprintjs/core";
import classNames from "classnames";
import React from "react";
// import { withPrefix } from "gatsby";
import { default as DefaultLayout } from "../layouts";

import styles from "./about.module.css";

const videoUrl = "https://digital-dance-hall.s3.amazonaws.com/assets/about-documentation.mp4";
// const videoUrl = withPrefix("/video/about-documentation.mp4");

export default function AboutPage() {
    return (
        <DefaultLayout className={classNames(styles.container, Classes.DARK)}>
            <div className={styles.hero} />
            <div className={styles.centerContainer}>
                <div className={Classes.RUNNING_TEXT}>
                    <H2>Digital Dance Hall is a social video platform for internet dance parties</H2>
                    <p className={Classes.TEXT_LARGE}>
                        Experience design for nightclubs and dance parties has always been propelled by new technologies
                        and mediums, but in the wake of a global pandemic, we're seeing a lot more efforts to create
                        meaningful party experiences online.
                        <br /> <br />
                        Digital Dance Hall is a platform for an underground dance music community which is underserved
                        by existing digital products and tools. Its design takes into consideration the needs and roles
                        of DJs, lighting designers, promoters, and party-goers; its features adapt rituals and behaviors
                        from physical dance spaces into digital UX patterns. <br /> <br />
                        We hope that parties facilitated by Digital Dance Hall can serve some of the functions of their
                        physical counterparts, as places for community building, presentation of forward-thinking music
                        culture, and the creation of new performative versions of our self identities.
                    </p>
                </div>
            </div>
            <div className={styles.centerContainer}>
                <video src={videoUrl} muted={true} autoPlay={true} loop={true} />
                <div className={classNames(Classes.RUNNING_TEXT, styles.narrowTextContainer)}>
                    <H3>Features</H3>
                    <p className={Classes.TEXT_LARGE}>
                        <ul>
                            <li>
                                Self-hosted parties (audio streamed over WebRTC) or embedded livestreams (Twitch,
                                Livestream, Vimeo, etc.)
                            </li>
                            <li>Anonymous login</li>
                            <li>Flexible video layout (keep track of your friends easily)</li>
                            <li>Public chat room (images, gifs, emojis...)</li>
                            <li>Private chat (request / block system)</li>
                            <li>Cameras always enabled (to prevent lurking)</li>
                            <li>Virtual backgrounds</li>
                            <li>Dancer spotlight</li>
                        </ul>
                    </p>
                </div>
            </div>
            <div className={styles.centerContainer}>
                <div className={Classes.RUNNING_TEXT}>
                    <H2>Contact</H2>
                    <p className={Classes.TEXT_LARGE}>
                        Interested in using Digital Dance Hall?{" "}
                        <a href="https://twitter.com/digidancehall" target="_blank">
                            Shoot us a DM on Twitter @digidancehall
                        </a>
                        .
                    </p>
                </div>
            </div>
        </DefaultLayout>
    );
}
